import { Link } from "react-router-dom";
import { PageHero, CTABand } from "@/components/site/PageHero";
import { Container, Reveal } from "@/lib/ui";
import { ASSET_CLASSES, IMAGES } from "@/data/site";
import { ASSET } from "@/constants/testIds";

export default function AssetClasses() {
  return (
    <>
      <PageHero
        id="asset-classes"
        overline="Asset Classes"
        title="One operating standard across every asset type."
        lead="From multifamily and build-to-rent to hospitality and commercial, our teams apply consistent, institutional-grade operations tuned to the demands of each asset class."
        image={IMAGES.hero}
      />

      <section className="py-24 md:py-32 bg-[#F7F7F5]">
        <Container>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {ASSET_CLASSES.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 0.06}>
                <div data-testid={ASSET.card(a.slug)} className="group bg-white border border-[#E5E5DF] rounded-sm overflow-hidden h-full">
                  <div className="overflow-hidden aspect-[16/10]">
                    <img src={a.image} alt={`${a.name} real estate managed by GreatLeaf`} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <h2 className="font-display text-2xl text-[#121A16]">{a.name}</h2>
                    <p className="mt-2 text-sm text-[#5C6660] leading-relaxed">{a.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-12">
            <Link to="/contact" className="inline-flex items-center gap-2.5 rounded-sm bg-[#1B3B2B] text-white px-8 py-4 text-sm font-medium hover:bg-[#275C43] transition-colors">
              Discuss your portfolio
            </Link>
          </div>
        </Container>
      </section>

      <CTABand />
    </>
  );
}
